<template>
  <footer class="pageFooter">
    <p>Copyright soundcheck 2018</p>
  </footer>
</template>

<script>
export default {};
</script>

<style>
.pageFooter {
position: fixed;
right: 0;
left: 0;
bottom: 0;
width: 100%;
padding-top: 0.8rem;
padding-left: 1rem;
line-height: 0.4rem;
font-size: 0.5rem;
display: flex;
background-color: rgba(0, 0, 0, 0.5);
color: white;
}
</style>